import * as Global from 'styles/global/global.styles';

export function Container() {
    return {
        borderBottom: `1px solid ${Global.colors().__header.headerBorder}`,
        display: 'flex',
        justifyContent: 'space-between',
        height: Global.header().height,
        backgroundColor: '#fff',
        alignItems: 'center',
    };
}

export function LoginIslandContainer() {
    return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    };
}

export function button(isMobile: boolean, isAuthenticated: boolean) {
    return {
        height: '35px',
        m: '0 1rem',
        width: isMobile ? '50vw' : 'auto',
        backgroundColor: isAuthenticated ? '#cc0000' : Global.colors().headers,
        '&:hover': {
            backgroundColor: isAuthenticated ? '#990000' : Global.colors().headers,
        },
    };
}

export function userName() {
    return {
        margin: '0 1rem',
    };
}

export function authenticatedUserContainer() {
    return {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    };
}
